'use es6';

import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function CalleeSelectMessage({
  message,
  className
}) {
  return /*#__PURE__*/_jsx("div", {
    className: `p-x-3 p-y-5 ${className}`,
    children: message
  });
}
export default /*#__PURE__*/memo(CalleeSelectMessage);